import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FullPageLayout from "../../../components/FullPageLayout";
import ResourceViewer from "../../../components/ResourceViewer/ResourceViewer";
import { useItems } from "../../../hooks/learningCenter/contentRepository/items";

const RepositoryItemViewer = () => {
  const [repositoryItem, setRepositoryItem] = useState(null);
  const { itemId } = useParams();
  const { findItem } = useItems();

  useEffect(() => {
    findItem({ id: itemId, include: "latest_version" }).then(setRepositoryItem);
  }, []);

  if (repositoryItem) {
    return (
      <ResourceViewer
        {...repositoryItem.latestVersion}
        // we need to close the tab opened by links in CKEditor marked as open in new tab
        closeNewTabAfterOpeningLink={true}
        LayoutComponent={FullPageLayout}
        onExit={() => window.close()}
      />
    );
  } else {
    return null;
  }
};

export default RepositoryItemViewer;
